import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './StoreLinkCard.css';

export default function StoreLinkCard({ platform, storeName, url, badgeSrc, qrFileName }) {
  const qrRef = useRef(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      window.showNotification?.('success', 'Link kopyalandı');
    } catch {
      window.showNotification?.('error', 'Kopyalanamadı');
    }
  };

  const handleDownloadQr = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = qrFileName || 'unmak-store-qr.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  return (
    <article className="store-link-card">
      <div className="store-link-card-head">
        <a href={url} target="_blank" rel="noopener noreferrer" className="store-link-badge-link">
          <img src={badgeSrc} alt={`${storeName} indir`} className="store-link-badge" />
        </a>
        <div className="store-link-meta">
          <h2>{platform}</h2>
          <span>{storeName}</span>
        </div>
      </div>

      <div className="store-link-url-row">
        <code className="store-link-url">{url}</code>
        <button type="button" className="store-link-copy" onClick={handleCopy}>
          <i className="fas fa-copy" aria-hidden="true" />
          Kopyala
        </button>
      </div>

      <div className="store-link-qr-block">
        <div className="store-link-qr-wrap" ref={qrRef}>
          <QRCodeCanvas value={url} size={168} level="M" includeMargin />
        </div>
        <div className="store-link-qr-actions">
          <a href={url} target="_blank" rel="noopener noreferrer" className="store-link-open">
            Mağazaya git
          </a>
          <button type="button" className="store-link-download" onClick={handleDownloadQr}>
            <i className="fas fa-download" aria-hidden="true" />
            QR indir
          </button>
        </div>
      </div>
    </article>
  );
}
